.sq-message-container {
  width: 100%;
  padding: 10px;
  font-family: 'Open Sans', sans-serif;
}

.sq-message-container h1 {
  font-size: 28px;
  font-weight: 600;
}

.sq-message-container h2 {
  font-size: 24px;
  font-weight: 600;
}

.sq-message-container h3 {
  font-size: 20px;
}

.sq-message-container p {
  line-height: 28px;
  font-weight: 400;
}

.sq-message-container a {
  font-size: $font-size-sm-01 !important;
}

.sq-message-container b {
  color: black !important;
  font-weight: 700;
}
